
import React from "react";
import { SidebarProvider, SidebarTrigger } from "@/components/ui/sidebar";
import { TooltipProvider } from "@/components/ui/tooltip";
import { AppSidebar } from "@/components/AppSidebar";
import { BreadcrumbNavigation } from "@/components/BreadcrumbNavigation";
import { EnhancedMobileNavigation } from "@/components/mobile/EnhancedMobileNavigation";
import { PWAInstallPrompt } from "@/components/mobile/PWAInstallPrompt";
import { OfflineIndicator } from "@/components/mobile/OfflineIndicator";
import { PWAFeatures } from "@/components/PWAFeatures";
import { GlobalSearch } from "@/components/GlobalSearch";
import { QuickActions } from "@/components/QuickActions";
import { WorkspaceStatusBar } from "@/components/WorkspaceStatusBar";
import { useIsMobile } from "@/hooks/use-mobile";
import { useKeyboardShortcuts } from "@/hooks/useKeyboardShortcuts";
import { useBrand } from "@/hooks/useBrand";
import { Outlet } from "react-router-dom";
import { TrialStatusBanner } from "@/components/trial/TrialStatusBanner";

export function DashboardLayout() {
  const isMobile = useIsMobile();
  
  // Initialize keyboard shortcuts and branding
  useKeyboardShortcuts();
  useBrand();

  if (isMobile) {
    return (
      <>
        <EnhancedMobileNavigation />
        <OfflineIndicator />
        <div className="pt-16 pb-20 min-h-screen">
          <main className="p-4">
            <Outlet />
          </main>
        </div>
        <PWAInstallPrompt />
        <PWAFeatures />
      </>
    );
  }

  return (
    <TooltipProvider delayDuration={0}>
      <SidebarProvider>
        <div className="flex min-h-screen w-full">
          <AppSidebar />
          <div className="flex-1 flex flex-col">
            <div className="border-b border-sidebar-border bg-background">
              <div className="flex items-center justify-between px-6 py-2">
                <div className="flex items-center gap-4">
                  <SidebarTrigger />
                  <BreadcrumbNavigation />
                </div>
              </div>
            </div>
            <main className="flex-1 p-6">
              <TrialStatusBanner />
              <Outlet />
            </main>
          </div>
        </div>
        <PWAInstallPrompt />
        <OfflineIndicator />
        <PWAFeatures />
      </SidebarProvider>
    </TooltipProvider>
  );
}
